import { startAppListening } from "../../../listener-middleware";
import { loadRouteViewModels } from "../route-views";
import { loadCalendarViewData } from "../calendar-view";
import { loadDriversActivitiesForViews } from ".";

// How long to hold the activity fetch back waiting for GET /api/features. If
// it never arrives (request failed), fetch anyway with the flags unknown,
// which falls back to the activity log rather than showing no statuses.
const FEATURES_WAIT_TIMEOUT_MS = 10_000;

type ListenerApi = Parameters<
  Parameters<typeof startAppListening>[0]["effect"]
>[1];

// A route/calendar view load on a fresh page usually starts before
// GET /api/features has returned. Deciding then whether the activity log is
// needed reads every flag as off and fires one request per route (DORA-259),
// so wait for features before deciding.
const loadActivitiesOnceFeaturesLoaded = async (
  routeIds: string[],
  api: ListenerApi
) => {
  if (!routeIds.length) {
    return;
  }
  if (!api.getState().features.initialLoad) {
    await api.condition(
      (_, state) => state.features.initialLoad,
      FEATURES_WAIT_TIMEOUT_MS
    );
  }
  api.dispatch(loadDriversActivitiesForViews(routeIds));
};

export const startDriverActivitiesListeners = () => {
  startAppListening({
    actionCreator: loadRouteViewModels.fulfilled,
    effect: (action, api) =>
      loadActivitiesOnceFeaturesLoaded(
        action.payload.map((r) => r.id),
        api
      ),
  });
  startAppListening({
    actionCreator: loadCalendarViewData.fulfilled,
    effect: (action, api) =>
      loadActivitiesOnceFeaturesLoaded(
        action.payload.flatMap((d) => d.routes.map((r) => r.id)),
        api
      ),
  });
};
